export default {
    init() {
    },
    finalize() {
        // var form = document.getElementById('cancel-subscription');
        // if (form !== null) {
        //     form.addEventListener('submit', function (event) {
        //         console.log('form submit listener');

        //         event.preventDefault();

        //         if (form.classList.contains('waiting')) {
        //             return;
        //         }

        //         var button = form.querySelector('button[type="submit"]');
        //         var input = form.querySelector('.input');
        //         var message = input.querySelector('textarea');
        //         var error_message = input.querySelector('.input-message');
        //         var cancel_url = form.querySelector('[name=cancel_url]').value;

        //         if (message.value.length < 10) {
        //             input.classList.add('is-error');
        //             error_message.innerHTML = "Please enter a longer reason.";
        //         }
        //         else {
        //             button.classList.add('waiting');
        //             form.classList.add('waiting');

        //             var form_data = jQuery(this).serialize();

        //             jQuery.ajax({
        //                 type: "POST",
        //                 url: "/wp-json/gp_forms/v1/submit/cancel-subscription?_wpnonce=" + nonce[1],
        //                 data: form_data
        //             }).done(function (response) {
        //                 if (response.hasErrors !== false) {
        //                     error_message.innerHTML = "An error occured. Please contact us for assistance.";
        //                 }
        //                 else {
        //                     window.location.href = cancel_url;
        //                 }
        //             });

        //         }


        //     });
        // }

        /** Reset cancellation process on modal close */
        jQuery('.overlay__close').on('click', function (e) {
            jQuery('.form-cancel-subscription-laststep').hide();
            jQuery('.form--cancel-subscription-container > div').hide();
            jQuery('.cancel-subscription-list-container').show();
        });

        function addParameterToURL(param) {
            var _url = location.href;
            _url += (_url.split('?')[1] ? '&' : '?') + param;
            return _url;
        }

        function parseQuery(queryString) {
            var query = {};
            var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
            for (var i = 0; i < pairs.length; i++) {
                var pair = pairs[i].split('=');
                query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
            }
            return query;
        }

        function cancelModalRedirect(feedback = '') {
            console.log('cancelModalRedirect');

            var container = jQuery('.overlay-cancel-subscription');
            var cancel = container.find('input[name=cancel]').val();

            var reason = jQuery('.overlay-cancel-subscription input[name=reason]').val();

            var pauseLink = container.find('input[name=actionlink]').val();
            var pauseLinkObject = parseQuery(pauseLink);

            // customer.io data
            var willCancel = cancel == 1 ? true : false;
            var data = {
                reason: reason,
                cancelled: willCancel ? 'yes' : 'no',
                user_id: jQuery('.overlay-cancel-subscription').data('userid'),
            };

            switch (reason) {
                case 'forgotToTake':
                case 'tooMany': {
                    if (!willCancel) {
                        data.paused = pauseLinkObject.pause_subscription;
                    }
                } break;
                case 'notHappy':
                case 'other': {
                    data.feedback = feedback;
                    data.cancelled = 'yes';
                } break;
                case 'tooExpensive': {
                    if (!willCancel) {
                        var discountCode = jQuery('.overlay-cancel-subscription input[name=discountcode]').val();
                        data.discount = discountCode;
                    }
                } break;
                case 'needTime': {
                    if (!willCancel) {
                        if (cancel == 4) {
                            data.action = 'stay_subscribed';
                        } else {
                            data.paused = pauseLinkObject.pause_subscription;
                        }
                    }
                } break;
            }

            data.subscription_id = window.cancellation_subscription_id;

            console.log(data);

            jQuery.ajax({
                type: "POST",
                url: "/wp-json/q/v1/cancellation/submit",
                data: data,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', nonce[1]);
                }
            }).done(function (response) {

                console.log({cancel});

                if (cancel == 0) {
                    var pauseLink = container.find('input[name=actionlink]').val();
                    var pauseLinkComplete = window.location.href + pauseLink;
                    console.log('redirect',pauseLinkComplete);
                    window.location.replace(pauseLinkComplete);
                } else if (cancel == 1) {
                    var cancelLink = container.find('input[name=cancellink]').val();
                    console.log('redirect',cancelLink);
                    window.location.href = cancelLink;
                } else if (cancel == 3) {
                    var discountLink = jQuery('.overlay-cancel-subscription input[name=discountlink]').val();
                    console.log('redirect',discountLink);
                    window.location.href = discountLink;
                } else if (cancel == 4) {
                    var reloadUrl = addParameterToURL('cancelsubscription=false');
                    console.log('redirect',reloadUrl);
                    window.location.href = reloadUrl;
                }

            });

        }

        jQuery('#cancel-subscription textarea').keyup(function () {

            if (jQuery(this).val().length >= 10) {
                jQuery('#cancel-subscription .input').removeClass('is-error');
                jQuery('#cancel-subscription .input-message').empty();
            }

        });

        // attach checked class 
        jQuery('.cancel-subscription-list-form input[type=radio]').on('click', function (e) {
            var radioButtons = jQuery('.cancel-subscription-list-form input[type=radio]');
            radioButtons.each(function (i, item) {
                var isChecked = jQuery(item).is(':checked');
                if (isChecked) {
                    jQuery(item).parents('.radio-cancel-subscription').addClass('checked');
                } else {
                    jQuery(item).parents('.radio-cancel-subscription').removeClass('checked');
                }
            });
        });

        // THIS FIRST??
        jQuery('.cancel-subscription-list-form').on('submit', function (e) {

            console.log('cancel-subscription-list-form form submit');
            e.preventDefault();

            var $form = jQuery(this);
            var selectedReason = $form.find('.cancel-subscription-list input[name=cancelreason]:checked').val();

            // show the form for the selected reason
            if (selectedReason) {

                $form.find('.is-error-text').css('visibility', 'hidden');
                var selectedBlockSelector = '.form--cancel-subscription-container' + ' .' + selectedReason;
                jQuery('.overlay-cancel-subscription input[name=reason]').val(selectedReason);

                // scroll to top 
                document.getElementById('overlay_maincontent').scrollTop = 0;

                jQuery('.cancel-subscription-list-container').fadeOut(400, () => {
                    jQuery(selectedBlockSelector).fadeIn();
                });

            } else {

                $form.find('.is-error-text').css('visibility', 'visible');
                var overlayContainer = document.getElementById('overlay_maincontent');
                overlayContainer.scrollTop = overlayContainer.scrollHeight - overlayContainer.clientHeight;

            }

        });

        // forgotToTake
        jQuery('.forgotToTake .pause_subscription').on('click', function (e) {

            e.preventDefault();

            var pauseLink = $(this).data('pauselink');

            jQuery('.overlay-cancel-subscription input[name=actionlink]').val(pauseLink);

            jQuery('.form--cancel-subscription-container').fadeOut(400, () => {
                jQuery('.form-cancel-subscription-laststep--stay').show();
                jQuery('#overlay_maincontent .h3').hide();
                jQuery('.form-cancel-subscription-laststep').fadeIn();
                cancelModalRedirect();
            });

        });

        jQuery('.forgotToTake .form-subscription-cancel-link').on('click', function (e) {

            e.preventDefault();

            jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

            jQuery('.form--cancel-subscription-container').fadeOut(400, () => {
                jQuery('.form-cancel-subscription-laststep--cancel').show();
                jQuery('.form-cancel-subscription-laststep').fadeIn();
                cancelModalRedirect();
            });

        });

        // tooMany
        jQuery('.tooMany .pause_subscription').on('click', function (e) {

            e.preventDefault();

            var pauseLink = $(this).data('pauselink');

            jQuery('.overlay-cancel-subscription input[name=actionlink]').val(pauseLink);

            jQuery('.form--cancel-subscription-container').fadeOut(400, () => {
                jQuery('.form-cancel-subscription-laststep--stay').show();
                jQuery('#overlay_maincontent .h3').hide();
                jQuery('.form-cancel-subscription-laststep').fadeIn();
                cancelModalRedirect();
            });

        });

        jQuery('.tooMany .form-subscription-cancel-link').on('click', function (e) {

            e.preventDefault();

            jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

            jQuery('.form--cancel-subscription-container').fadeOut(400, () => {
                jQuery('.form-cancel-subscription-laststep--cancel').show();
                jQuery('.form-cancel-subscription-laststep').fadeIn();
                cancelModalRedirect();
            });

        });

        // notHappy
        jQuery('.notHappy form').on('submit', function (e) {

            e.preventDefault();
            var cancelFeedback = jQuery(this).find('.cancelfeedback').val();

            if (cancelFeedback.length < 10) {
                jQuery(this).find('.input').addClass('is-error');
                jQuery(this).find('.input-message').text('Please enter a longer reason.');
            } else {

                jQuery('.form-cancel-subscription-laststep--cancel').show();
                jQuery('.form-cancel-subscription-laststep').fadeIn();
                jQuery('#overlay_maincontent .h3').hide();
                jQuery('.form--cancel-subscription-container').hide();
                jQuery(this).find('button').addClass('waiting');

                jQuery(this).find('.input').removeClass('is-error');
                jQuery(this).find('.input-message').text('');

                // jQuery(this).find('button').addClass('waiting');

                jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

                // save feedback 
                cancelModalRedirect(cancelFeedback);

            }

        });

        // tooExpensive
        jQuery('.tooExpensive .apply-discount').on('click', function (e) {

            e.preventDefault();

            jQuery('.overlay-cancel-subscription input[name=cancel]').val('3');

            jQuery('.form--cancel-subscription-container').fadeOut(400, () => {
                jQuery('.form-cancel-subscription-laststep--stay').show();
                jQuery('#overlay_maincontent .h3').hide();
                jQuery('.form-cancel-subscription-laststep').fadeIn();
                cancelModalRedirect();
            });

        });

        jQuery('.tooExpensive .form-subscription-cancel-link').on('click', function (e) {

            e.preventDefault();

            jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

            jQuery('.form--cancel-subscription-container').fadeOut(400, () => {
                jQuery('.form-cancel-subscription-laststep--cancel').show();
                jQuery('.form-cancel-subscription-laststep').fadeIn();
                cancelModalRedirect();
            });

        });

        // needTime
        jQuery('.needTime .stay-subscribed').on('click', function (e) {

            e.preventDefault();

            jQuery('.overlay-cancel-subscription input[name=cancel]').val('4');

            jQuery('.form--cancel-subscription-container').fadeOut(400, () => {
                jQuery('.form-cancel-subscription-laststep--stay').show();
                jQuery('#overlay_maincontent .h3').hide();
                jQuery('.form-cancel-subscription-laststep').fadeIn();
                cancelModalRedirect();
            });

        });

        jQuery('.needTime .form-subscription-cancel-link').on('click', function (e) {

            e.preventDefault();

            jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

            jQuery('.form--cancel-subscription-container').fadeOut(400, () => {
                jQuery('.form-cancel-subscription-laststep--cancel').show();
                jQuery('.form-cancel-subscription-laststep').fadeIn();
                cancelModalRedirect();
            });

        });

        jQuery('.needTime .pause_subscription').on('click', function (e) {

            e.preventDefault();

            var pauseLink = $(this).data('pauselink');

            jQuery('.overlay-cancel-subscription input[name=actionlink]').val(pauseLink);

            jQuery('.form--cancel-subscription-container').fadeOut(400, () => {
                jQuery('.form-cancel-subscription-laststep--stay').show();
                jQuery('.form-cancel-subscription-laststep').fadeIn();
                cancelModalRedirect();
            });

        });

        // other
        jQuery('.other form').on('submit', function (e) {

            e.preventDefault();
            var cancelFeedback = jQuery(this).find('.cancelfeedback').val();

            if (cancelFeedback.length < 10) {
                jQuery(this).find('.input').addClass('is-error');
                jQuery(this).find('.input-message').text('Please enter a longer reason.');
            } else {
                jQuery(this).find('.input').removeClass('is-error');
                jQuery(this).find('.input-message').text('');

                jQuery(this).find('button').addClass('waiting');

                jQuery('.form-cancel-subscription-laststep--cancel').show();
                jQuery('.form-cancel-subscription-laststep').fadeIn();
                jQuery('#overlay_maincontent .h3').hide();
                jQuery('.form--cancel-subscription-container').hide();

                jQuery(this).find('.input').removeClass('is-error');
                jQuery(this).find('.input-message').text('');

                jQuery('.overlay-cancel-subscription input[name=cancel]').val('1');

                cancelModalRedirect(cancelFeedback);

            }

        });

    }
};


// WEBPACK FOOTER //
// ./js/routes/woocommerce-account-view-subscription.js